import React, { useState, useRef } from 'react';
import './ResumeEditor.css'; // Make sure your CSS is imported so the buttons are styled

export function ProfileImageUploader({ resumeHtml, setResumeHtml, setEditedData, saveToHistory }) {
  const [profileImage, setProfileImage] = useState(null);
  const fileInputRef = useRef(null);

  // Called when the file input changes
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setProfileImage(reader.result); // Data URL of the image
      };
      reader.readAsDataURL(file);
    }
  };

  // Called when the user confirms the upload
  const handleUpdateProfileImage = () => {
    saveToHistory();
    // Parse the current resumeHtml into a document
    const parser = new DOMParser();
    const doc = parser.parseFromString(resumeHtml, "text/html");
    // Find the profile image element
    const imgEl = doc.querySelector("header .profile-image-container img");
    if (imgEl) {
      imgEl.src = profileImage;
    }
    // Get the updated HTML string
    const updatedHtml = doc.documentElement.outerHTML;
    setResumeHtml(updatedHtml);
    // Also update editedData so the image persists in state
    setEditedData(prev => ({
      ...prev,
      contact_information: { 
        ...prev.contact_information, 
        profile_image: profileImage 
      }
    }));
  };


  return (
    <div>
      <h3>Upload Profile Image</h3>
      
      {/* Hidden file input */}
      <input
        id="fileInput"
        type="file"
        accept="image/*"
        onChange={handleFileChange}
        ref={fileInputRef}
        style={{ display: 'none' }}
      />
      
      {/* Centered container for buttons */}
      <div style={{ textAlign: 'center' }}>
        {/* “Choose File” button styled via CSS file */}
        <div className="text-controls" style={{ marginBottom: '10px' }}>
          <button 
            type="button"
            onClick={() => fileInputRef.current.click()}
          >
            Choose File
          </button>
        </div>
        
        {profileImage && (
          <div>
            <p>Preview:</p>
            <img 
              src={profileImage} 
              alt="Profile Preview" 
              style={{ maxWidth: "150px", borderRadius: "50%" }} 
            />
            <br />
            {/* “Update Profile Image” button styled via CSS file */}
            <div className="text-controls" style={{ marginTop: '10px' }}>
              <button 
                type="button"
                onClick={handleUpdateProfileImage}
              >
                Update Profile Image
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}